import React from "react";
import SectionHeader from "../../utilis/SectionHeader";
import { MdOutlineSecurity } from "react-icons/md";
import { MdNotificationsActive } from "react-icons/md";
import { FaChartPie } from "react-icons/fa";

const FeatureSection = () => {
  const content = [
    {
      icon: <MdOutlineSecurity />,
      title: "Secured Payment Service",
      listOne:
        "Adipiscing elild neque, diam nim etus porta viverra pretium auctor nam sed.",
      listTwo:
        "Lorem neque, diam nim etus porta viverra pretium auctor ut nam sed.",
    },
    {
      icon: <FaChartPie />,
      title: "Low Cost & Fast Exchange",
      listOne:
        "Adipiscing elild neque, diam nim etus porta viverra pretium auctor nam sed.",
      listTwo:
        "Lorem neque, diam nim etus porta viverra pretium auctor ut nam sed.",
    },
    {
      icon: <MdNotificationsActive />,
      title: "Real Time Money Tracking",
      listOne:
        "Adipiscing elild neque, diam nim etus porta viverra pretium auctor nam sed.",
      listTwo:
        "Lorem neque, diam nim etus porta viverra pretium auctor ut nam sed.",
    },
  ];

  return (
    <div className="feature_section section-padding">
      <div className="container px-sm-1 px-4">
        {/* HEADING SECTION */}
        <div className="row padding-bottom">
          <div className="col-lg-6 col-sm-10 mx-auto" data-aos="zoom-in">
            <SectionHeader
              subTitle="PMAIN FEATURES"
              title="We Care Very Much About Our Customer Satisfaction"
            />
          </div>
        </div>

        {/* CONTENT SECTION */}
        <div className="row">
          {content.map((element, index) => {
            return (
              <div className="col-lg-4 col-sm-6 mb-lg-1 mb-4" key={index} data-aos='fade-up'>
                <div className="feature_card shadow rounded-4 bg-white p-4">
                  <div className="feature_img">{element.icon}</div>
                  <div className="feature_body mt-4">
                    <h5 className="text-black fw-700 mb-4">{element.title}</h5>
                    <ul className="list-unstyled">
                      <li className="mb-2 d-flex align-items-start">
                        <p className="list_icon mb-0 pe-3 text-green ">
                          <i class="fa-regular fa-circle-check"></i>
                        </p>
                        <p className="mb-0 text-color">{element.listOne}</p>
                      </li>
                      <li className="mb-2 d-flex align-items-start">
                        <p className="list_icon mb-0 pe-3 text-green ">
                          <i class="fa-regular fa-circle-check"></i>
                        </p>
                        <p className="mb-0 text-color">{element.listTwo}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeatureSection;
